<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("profile.mfaTitle") }}</h5>
    <vue-element-loading :active="isLoading" spinner="spinner" />
    <div class="card">
      <div class="card-content">
        <h6 class="title is-6">1. {{ $t("profile.mfaTitle2") }}</h6>
        <p class="description">
          認証アプリでQRCODEを読み取ってください。
        </p>
        <img :src="image" class="qrcode" />
        <h6 class="title is-6 mt-4">2. {{ $t("profile.mfaTitle3") }}</h6>
        <p class="description">
          認証アプリに表示された確認コード（6桁）を入力してください。
        </p>
        <Form
          @submit="onSubmit"
          :validation-schema="schema"
          :initial-values="formValues"
          v-slot="{ errors }"
        >
          <div class="field mt-2">
            <label class="label">{{ $t("profile.userCode") }} *</label>
            <div class="control">
              <Field
                name="userCode"
                class="input usercode"
                type="text"
                maxlength="6"
                required="required"
                :class="{ 'is-danger': errors.UserCode }"
              />
              <span class="help is-danger">{{ errors.userName }}</span>
            </div>
          </div>
          <router-link
            :to="{
              name: 'profileView',
            }"
            class="button"
            :data-tooltip="$t('Back')"
          >
            Cancel
          </router-link>

          <button
            type="submit"
            class="button is-primary ml-3"
            v-bind:class="{ 'is-loading': isLoad }"
          >
            {{ $t("Confirm") }}
          </button>
        </Form>

        <div v-if="errorMessage" class="notification is-light is-danger mt-3">
          {{ $t("profile.userCodeError") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { ImsrUsers } from "@/lib/imsrUsers.js";
import { ref } from "@vue/reactivity";
import { Field, Form } from "vee-validate";
import VueElementLoading from "vue-element-loading";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import * as Yup from "yup";

export default {
  components: {
    Breadcrumb,
    VueElementLoading,
    Form,
    Field,
  },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    const breadcrumb = ref([
      { title: "Home", path: "/" },
      { title: "Profile", path: { name: "profileView" } },
      { title: "MFA", path: "#", isActive: true },
    ]);
    const formValues = ref({});
    const isLoading = ref(false);
    const isLoad = ref(false);
    const image = ref("/img/blank.png");
    const errorMessage = ref("");

    const schema = Yup.object().shape({
      userCode: Yup.string().required(t("validate.required")),
    });

    const getToken = async () => {
      try {
        isLoading.value = true;
        const imsrUsers = new ImsrUsers();
        image.value = await imsrUsers.getSoftToken(store.getters.tenantId);
        isLoading.value = false;
      } catch (e) {
        console.log("cant get token"); // eslint-disable-line no-console
      }
    };
    getToken();

    const onSubmit = async (values) => {
      try {
        isLoad.value = true;
        const imsrUsers = new ImsrUsers();
        const res = await imsrUsers.verifyToken(
          store.getters.tenantId,
          values.userCode
        );
        if (res) {
          store.commit("setMessage", t("profile.mfaSet"));
          router.push({ name: "profileView" });
        } else {
          errorMessage.value = t("profile.userCodeError");
        }
        isLoad.value = false;
      } catch (e) {
        errorMessage.value = "System error";
      }
    };

    return {
      breadcrumb,
      isLoading,
      image,
      formValues,
      schema,
      isLoad,
      onSubmit,
      errorMessage,
    };
  },
};
</script>
<style>
.qrcode {
  width: 128px;
}
.description {
  margin-top: -12px;
}
.usercode {
  max-width: 200px;
}
</style>
